var Writaholics = Writaholics || {};

Writaholics.Counters = function () {

	var _counterValue = '.counter__value';

	var _init = function () {
		_startCounter();
	}

	var _incrementCounter = function (entry) {
		jQuery(entry.target).each(function () {
			var _this = jQuery(this);
			jQuery({ Counter: 0 }).animate({ Counter: _this.text() }, {
				duration: 3000,
				easing: 'swing',
				step: function () {
					_this.text(Math.ceil(this.Counter));
				}
			});
		});
	}

	var _startCounter = function () {
		let observer = new IntersectionObserver((entries) => {
			entries.map((entry) => {
				if (entry.isIntersecting) {
					_incrementCounter(entry);
					observer.unobserve(entry.target);
				}
			});
		},{ threshold: 1});
		document.querySelectorAll(_counterValue).forEach(counter => { observer.observe(counter) });
	}

	/** PUBLIC API **/
	return {
		init: function () { return _init(); }
	};

}();

jQuery(function () {
	Writaholics.Counters.init();
});
